import { ReactComponent as IconProcessSvg1 } from '../../assets/svg/icon-process1.svg';
import { ReactComponent as IconProcessSvg2 } from '../../assets/svg/icon-process2.svg';
import { ReactComponent as IconProcessSvg3 } from '../../assets/svg/icon-process3.svg';
import { ReactComponent as IconProcessSvg4 } from '../../assets/svg/icon-process4.svg';
import { ReactComponent as IconProcessSvg5 } from '../../assets/svg/icon-process5.svg';
import { IconProcess } from '../../components/Icon';

const Steps = [
  {
    icon: <IconProcess component={IconProcessSvg1} />,
    title: '提交表单申请',
  },
  {
    icon: <IconProcess component={IconProcessSvg2} />,
    title: '官网沟通审核',
  },
  {
    icon: <IconProcess component={IconProcessSvg3} />,
    title: '合作洽谈',
  },
  {
    icon: <IconProcess component={IconProcessSvg4} />,
    title: '签约',
  },
  {
    icon: <IconProcess component={IconProcessSvg5} />,
    title: '实施代理',
  },
];

export default Steps;
